module.exports = OnSiteCtrl;

// @ngInject
function OnSiteCtrl($state, $anchorScroll, SiteVisitApi, Alert, localStorageService, moment) {
  try {
		var vm = this;
    vm.moduleName = 'OnSiteCtrl'
    
    console.log(vm.moduleName, localStorageService.get('state'))

    if (localStorageService.get('state') === null) {
      $state.go('unknown');
    }
    if (!localStorageService.get('visitId')) {
      return $state.go('unknown')
    };

    // Get station Norkring and INSA name from messages
    var getStationNames = function () {
      ['site', 'case', 'other'].forEach(function(category) {
        ['critical', 'notice', 'info'].forEach(function(importance) {
          JSON.parse(localStorageService.get('visitMessages')).forEach(function(message) {
            switch (message.subject) {
              case 'INSA name':
                vm.siteInsa = message.body;
                break;
              case 'Norkring name':
                vm.siteNorkring = message.body;
                break;
            };
          });
        });
      });
    };
    
    getStationNames();
    vm.case = JSON.parse(localStorageService.get('case'));

    vm.enterDateTime = new Date();
    vm.leaveDateTime = moment(vm.enterDateTime).add(4,'hours').endOf('hour').toDate();

    // Trime seconds and milliseconds
    vm.enterDateTime.setSeconds(0);
    vm.enterDateTime.setMilliseconds(0);
    vm.leaveDateTime.setSeconds(0);
    vm.leaveDateTime.setMilliseconds(0);

    // Set min and max values for onsite and offsite datetimes
    vm.enterDateTimeMin = moment(vm.enterDateTime).subtract(30,'minutes').toDate();
    vm.enterDateTimeMax = moment(vm.enterDateTime).add(2,'hours').toDate();
    vm.leaveDateTimeMin = moment(vm.enterDateTime).add(30,'minutes').toDate();
    vm.leaveDateTimeMax = moment(vm.enterDateTime).add(7,'days').toDate();
    // Trim minutes for offsite date 
    vm.leaveDateTime.setMinutes(0);

    console.log({enter: vm.enterDateTime, leave: vm.leaveDateTime});

    
    vm.onSite = function () {
      try {
        vm.busyMsg = "Check-in"
        vm.isBusy = true
        if (moment(vm.enterDateTime).unix() < moment().unix() - (30 * 60)) {
          vm.isBusy = false
          Alert.addAlert({ title: 'Error', message: 'The enter time is too early!' , type: 'errorAlert', alertClass: 'alert-danger'});
          $anchorScroll();
          return
        }
        if (moment(vm.enterDateTime).unix() > moment().unix() + (2 * 60 * 60)) {
          vm.isBusy = false
          Alert.addAlert({ title: 'Error', message: 'The enter time is too far ahead! ' , type: 'errorAlert', alertClass: 'alert-danger'});
          $anchorScroll();
          return
        }
        if (moment(vm.leaveDateTime).unix() > moment().unix() + (7 * 24 * 60 * 60)) {
          vm.isBusy = false
          Alert.addAlert({ title: 'Error', message: 'The estimated leave time is to far out!' , type: 'errorAlert', alertClass: 'alert-danger'});
          $anchorScroll();
          return
        }
        if (moment(vm.leaveDateTime).unix() <= moment(vm.enterDateTime).unix()) {
          vm.isBusy = false
          Alert.addAlert({ title: 'Error', message: 'The estimated leave time is less than enter time!' , type: 'errorAlert', alertClass: 'alert-danger'});
          $anchorScroll();
          return
        }

        SiteVisitApi.onSite(localStorageService.get('visitId'), moment(vm.enterDateTime).unix(), moment(vm.leaveDateTime).unix(), localStorageService.get('position')).then(
          function(data) {
            try {
              vm.isBusy = false
              localStorageService.set('state', data.visitStatus);
              localStorageService.set('onSiteDateTime', vm.enterDateTime);
              localStorageService.set('offSiteDateTime', vm.leaveDateTime);
              $state.go('messages')
            } catch(error) {
              vm.isBusy = false;
              Alert.addAlert({ title: 'Ooops - a system error has occurred', message: error, type: 'errorAlert', alertClass: 'alert-danger', report: true, appModule: vm.moduleName});
              $anchorScroll();
            }
          },
          function(error) {
            vm.isBusy = false
            Alert.addAlert({ title: 'Error', message: error, type: 'errorAlert', alertClass: 'alert-danger'});
            $anchorScroll();
          }
        )
      } catch(error) {
        vm.isBusy = false;
        Alert.addAlert({ title: 'Ooops - a system error has occurred', message: error, type: 'errorAlert', alertClass: 'alert-danger', report: true, appModule: vm.moduleName});
        $anchorScroll();
      }
    };
  } catch (error) {
		vm.isBusy = false;
		Alert.addAlert({ title: 'Ooops - a system error has occurred', message: error, type: 'errorAlert', alertClass: 'alert-danger', report: true, appModule: vm.moduleName} );
		$anchorScroll();
  }
};
